<section class="widget">
  <div class="heading">
    <div>
      <h2>{{ title }}</h2>
      <p>
        {{ count }} {{ count === 1 ? 'analysis' : 'analyses' }} returned from
        the last {{ responseDays }} {{ responseDays === 1 ? 'day' : 'days' }}.
      </p>
    </div>
    <div class="controls">
      <mat-form-field appearance="outline"
        ><mat-label>Days</mat-label
        ><input
          matInput
          type="number"
          min="1"
          max="365"
          [(ngModel)]="days"
          matTooltip="Number of previous days to query." /></mat-form-field
      ><mat-form-field appearance="outline"
        ><mat-label>Limit</mat-label
        ><input
          matInput
          type="number"
          min="1"
          max="100"
          [(ngModel)]="limit"
          matTooltip="Maximum analyses returned, up to 100." /></mat-form-field
      ><button
        mat-flat-button
        color="primary"
        (click)="load()"
        [disabled]="loading"
      >
        Load
      </button>
    </div>
  </div>
  @if (loading) {
    <app-loading-state></app-loading-state>
  } @else if (error) {
    <app-error-state [message]="error"></app-error-state>
  } @else if (!runs.length) {
    <app-empty-state
      message="No transcript analyses were found."
    ></app-empty-state>
  } @else {
    <div class="run-list">
      @for (run of runs; track run.sk || run.analysedAt || $index) {
        <button
          class="run"
          (click)="select(run)"
          matTooltip="Select this analysis to view its details"
        >
          <span
            ><strong>{{ run.sk || run.analysedAt || 'Analysis' }}</strong
            ><small
              >{{
                run.customerId || run.sessionId || run.pk || 'No identifier'
              }}
              · {{ run.productType || 'Unknown product' }}</small
            ></span
          ><span class="status">{{ run.analysisStatus || 'COMPLETED' }}</span>
        </button>
      }
    </div>
  }
  @if (selected) {
    <div class="details">
      <h3>Analysis details</h3>
      <dl>
        <dt>Timestamp</dt>
        <dd>{{ selected.sk || selected.analysedAt || '—' }}</dd>
        <dt>Customer ID</dt>
        <dd>{{ selected.customerId || '—' }}</dd>
        <dt>Session ID</dt>
        <dd>{{ selected.sessionId || '—' }}</dd>
        <dt>Plan number</dt>
        <dd>{{ selected.planNumber || '—' }}</dd>
        <dt>Product / brand</dt>
        <dd>{{ selected.productType || '—' }} / {{ selected.brand || '—' }}</dd>
        <dt>Findings</dt>
        <dd>
          PII: {{ selected.pii ? 'Yes' : 'No' }} · Risky advice:
          {{ selected.riskyAdvice ? 'Yes' : 'No' }} · Smoke/fire:
          {{ selected.smokeFireMentionCount || 0 }}
        </dd>
        <dt>Requests</dt>
        <dd>
          Engineer: {{ selected.engineerRequestCount || 0 }} · Human:
          {{ selected.humanRequestCount || 0 }}
        </dd>
      </dl>
    </div>
  }
</section>
